var map = {
	"./camp.png": 1959,
	"./circle.svg": 1732,
	"./creative.png": 1960,
	"./frontend.png": 1961,
	"./gamedesign.png": 1962,
	"./graphicdesign.png": 1963,
	"./junior.png": 1964,
	"./math-3-4.png": 1965,
	"./math-5-6.png": 1966,
	"./pc.png": 1967,
	"./pytpro-nosnake.png": 1968,
	"./pytpro.png": 1969,
	"./pytstart-nosnake.png": 1970,
	"./pytstart.png": 1971,
	"./quadrangle.svg": 1730,
	"./unity.png": 1972,
	"./videocontent.png": 1973,
	"./websites.png": 1974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1731;